import { MenuItem, TextField } from "@mui/material";
import { SelectOption } from "./MultiSelectFilter";

type SingleSelectFilterProps = {
  field: string;
  label: string;
  options: SelectOption[];
  value: string;
  disabled?: boolean;
  onChange: (field: string, value: string) => void;
};

export function SingleSelectFilter({
  field,
  label,
  options,
  value,
  disabled = false,
  onChange,
}: SingleSelectFilterProps) {
  return (
    <TextField
      select
      disabled={disabled}
      size="small"
      label={label}
      value={value}
      onChange={(e) => onChange(field, e.target.value)}
      sx={{ minWidth: 180 }}
    >
      <MenuItem value="">Any</MenuItem>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
